import { createSelector } from 'reselect';

import { getNormalizedVehicle } from 'app/shared/utils/vehicle';

import { getReduxCachePrefix, DEALER_FEATURES } from '../constants';

/**
 * @description reducer state getter
 */
export const getListingsFiltersReducer = ({ listingsFilters }) =>
  listingsFilters;

/**
 * @description reducer state getter
 */
export const getListingsReducer = ({ listings }) => listings;

export const selectListingsFirstDataRequestCompleted = createSelector(
  [getListingsReducer],
  ({ firstDataRequestCompleted }) => firstDataRequestCompleted,
);

export const selectListingsDataLoading = createSelector(
  [getListingsReducer],
  ({ dataRequestLoading }) => dataRequestLoading,
);

export const selectListingsDataFailure = createSelector(
  [getListingsReducer],
  ({ dataRequestError }) => dataRequestError,
);

export const getListingsCacheKey = ({
  dealer,
  page,
  sortBy,
  partialExternalId,
}) => {
  let currentDealers = '';
  if (dealer) {
    currentDealers = dealer
      .map(({ uuid }) => uuid)
      .sort()
      .join();
  }

  const currentPartialExternalId =
    (partialExternalId && partialExternalId[0]?.value) || ''; // only has one element
  const currentPage = page[0].uuid; // only has one element
  const currentSorting = Object.values(sortBy[0]).join();
  return `${getReduxCachePrefix(
    DEALER_FEATURES.LISTINGS,
  )}${currentDealers}${currentPartialExternalId}${currentPage}${currentSorting}`;
};

export const selectListingsCacheValue = createSelector(
  [getListingsReducer, getListingsFiltersReducer],
  (listings, listingsFilters) => listings[getListingsCacheKey(listingsFilters)],
);

export const selectDealerListings = createSelector(
  [getListingsReducer],
  ({ dealerListings }) => {
    return dealerListings?.map(v => getNormalizedVehicle(v)) || [];
  },
);

export const selectDealerListingsCount = createSelector(
  [getListingsReducer],
  ({ dealerListingsCount }) => dealerListingsCount,
);
